import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IActividadHistorico, ICategorizacionTramiteHistorico, ITipoTramiteActividadHistorico, ITipoTramiteCostoHistorico, ITipoTramiteHistorico } from '../../shared/interfaces/database/configuracion';
import { ISecDependenciaHistorico, ISecPermisoHistorico, ISecCargoHistorico, ISecCargoPermisoHistorico } from '../../shared/interfaces/database/seguridad';
import { IGetConfiguracionActividadesHistorico, IGetTiposHistorico } from '../../shared/interfaces/database/pqrsd';

@Injectable({
  providedIn: 'root'
})
export class HistoricoEventoService {

  private readonly baseUrl = `${environment.apiUrl}/api/historico-evento`;

  constructor(private readonly http: HttpClient) { }

  //#region ITipoTramiteHistorico
  getTipoTramiteHistorico(tipoTramiteId: number): Observable<ITipoTramiteHistorico[]> {
    return this.http.get<ITipoTramiteHistorico[]>(`${this.baseUrl}/tipo-tramite/${tipoTramiteId}`);
  }

  getTipoTramiteHistoricoEliminados(): Observable<ITipoTramiteHistorico[]> {
    return this.http.get<ITipoTramiteHistorico[]>(`${this.baseUrl}/tipo-tramite/eliminados`);
  }
  //#endregion ITipoTramiteHistorico

  //#region ITipoTramiteActividadHistorico
  getTipoTramiteActividadHistorico(tipoTramiteId: number): Observable<ITipoTramiteActividadHistorico[]> {
    return this.http.get<ITipoTramiteActividadHistorico[]>(`${this.baseUrl}/tipo-tramite-actividad/${tipoTramiteId}`);
  }
  //#endregion ITipoTramiteActividadHistorico

  //#region ICategorizacionTramiteHistorico
  getCategorizacionTramiteHistorico(categorizacionTramiteId: number): Observable<ICategorizacionTramiteHistorico[]> {
    return this.http.get<ICategorizacionTramiteHistorico[]>(`${this.baseUrl}/categorizacion-tramite/${categorizacionTramiteId}`);
  }

  getCategorizacionTramiteHistoricoEliminado(): Observable<ICategorizacionTramiteHistorico[]> {
    return this.http.get<ICategorizacionTramiteHistorico[]>(`${this.baseUrl}/categorizacion-tramite/eliminados`);
  }
  //#endregion ICategorizacionTramiteHistorico

  //#region IActividadHistorico
  getActividadHistorico(actividadId: number): Observable<IActividadHistorico[]> {
    return this.http.get<IActividadHistorico[]>(`${this.baseUrl}/actividad/${actividadId}`);
  }

  getActividadHistoricoEliminado(): Observable<IActividadHistorico[]> {
    return this.http.get<IActividadHistorico[]>(`${this.baseUrl}/actividad/eliminados`);
  }
  //#endregion IActividadHistorico

  //#region SecDependenciaHistorico
  getSecDependenciaHistorico(secDependenciaId: number): Observable<ISecDependenciaHistorico[]> {
    return this.http.get<ISecDependenciaHistorico[]>(`${this.baseUrl}/dependencia/${secDependenciaId}`);
  }

  getSecDependenciaHistoricoEliminado(): Observable<ISecDependenciaHistorico[]> {
    return this.http.get<ISecDependenciaHistorico[]>(`${this.baseUrl}/dependencia/eliminados`);
  }
  //#endregion SecDependenciaHistorico

  //#region SecPermisoHistorico
  getSecPermisoHistorico(secPermisoId: number): Observable<ISecPermisoHistorico[]> {
    return this.http.get<ISecPermisoHistorico[]>(`${this.baseUrl}/permiso/${secPermisoId}`);
  }

  getSecPermisoHistoricoEliminado(): Observable<ISecPermisoHistorico[]> {
    return this.http.get<ISecPermisoHistorico[]>(`${this.baseUrl}/permiso/eliminados`);
  }
  //#endregion SecPermisoHistorico

  //#region PQRSD ActividadesHistorico
  getPqrsdActividadHistorico(actividadId: number): Observable<IActividadHistorico[]> {
    return this.http.get<IActividadHistorico[]>(`${this.baseUrl}/pqrsd/actividad/${actividadId}`);
  }

  getPqrsdActividadHistoricoEliminado(): Observable<IActividadHistorico[]> {
    return this.http.get<IActividadHistorico[]>(`${this.baseUrl}/pqrsd/actividad/eliminados`);
  }
  //#endregion PQRSD ActividadesHistorico

  //#region ConfiguracionActividadesHistorico
  getConfiguracionActividadesHistorico(tipoId: number): Observable<IGetConfiguracionActividadesHistorico[]> {
    return this.http.get<IGetConfiguracionActividadesHistorico[]>(`${this.baseUrl}/pqrsd/configuracion-actividades/${tipoId}`);
  }
  //#endregion ConfiguracionActividadesHistorico

  //#region TiposHistorico
  getTiposHistorico(tipoId: number): Observable<IGetTiposHistorico[]> {
    return this.http.get<IGetTiposHistorico[]>(`${this.baseUrl}/pqrsd/tipos/${tipoId}`);
  }

  getTiposHistoricoEliminados(): Observable<IGetTiposHistorico[]> {
    return this.http.get<IGetTiposHistorico[]>(`${this.baseUrl}/pqrsd/tipos/eliminados`);
  }
  //#endregion TiposHistorico

  //#region SecCargoHistorico
  getSecCargoHistorico(secCargoId: number): Observable<ISecCargoHistorico[]> {
    return this.http.get<ISecCargoHistorico[]>(`${this.baseUrl}/pqrsd/sec-cargo/${secCargoId}`);
  }

  getSecCargoHistoricoEliminado(): Observable<ISecCargoHistorico[]> {
    return this.http.get<ISecCargoHistorico[]>(`${this.baseUrl}/pqrsd/sec-cargo/eliminados`);
  }
  //#endregion SecCargoHistorico

  //#region SecCargoPermisoHistorico
  getSecCargoPermisoHistorico(secCargoPermisoId: number): Observable<ISecCargoPermisoHistorico[]> {
    return this.http.get<ISecCargoPermisoHistorico[]>(`${this.baseUrl}/pqrsd/sec-cargo-permiso/${secCargoPermisoId}`);
  }

  getSecCargoPermisoHistoricoEliminado(): Observable<ISecCargoPermisoHistorico[]> {
    return this.http.get<ISecCargoPermisoHistorico[]>(`${this.baseUrl}/pqrsd/sec-cargo-permiso/eliminados`);
  }
  //#endregion SecCargoPermisoHistorico
}
